// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2Cb0A","tabsholder":"style_tabsholder__2O4o1"};